import { namespace } from '../../../../../FrontendBundle/Resources/js/ofcs';
import AbstractGroupItem from '../item/abstractGroupItem';
import AbstractCommand from './abstractCommand';

/**
 * Replace items command
 *
 * @class ReplaceItemsCommand
 * @extends AbstractCommand
 */
export default class ReplaceItemsCommand extends AbstractCommand {
    constructor(itemCollection, selection, replacements) {
        super();
        this.itemCollection = itemCollection;
        this.selection = selection;
        this.replacements = replacements;
    }

    /**
     * Execute command
     */
    execute() {
        const newItems = [];
        const selectableItems = [];

        this.selection.clear();

        this.replacements.forEach(({ oldItem, newItem }) => {
            if (oldItem && newItem) {
                selectableItems.push(this._replaceItems(oldItem, newItem));
                newItems.push(newItem);
            }
        });

        this.selection.selectItems(selectableItems, true);
    }

    /**
     * Unexecute command
     */
    unexecute() {
        const oldItems = [];
        const selectableItems = [];

        this.selection.clear();

        this.replacements.forEach(({ oldItem, newItem }) => {
            if (oldItem && newItem) {
                selectableItems.push(this._replaceItems(newItem, oldItem));
                oldItems.push(oldItem);
            }
        });

        this.selection.selectItems(selectableItems, true);
    }

    _replaceItems(oldItem, newItem) {
        if (oldItem.getParent() instanceof AbstractGroupItem) {
            this._handleGroupItems(oldItem, newItem);
            return this._findRootGroup(newItem);
        }

        this.itemCollection.remove(oldItem);
        this.itemCollection.add(newItem);

        return newItem;
    }

    /**
     * Replace items in group and re add group to trigger correct rendering
     * @param {AbstractItem} oldItem
     * @param {AbstractItem} newItem
     * @private
     */
    _handleGroupItems(oldItem, newItem) {
        const groupItem = oldItem.getParent();
        const rootGroup = this._findRootGroup(oldItem);

        if (groupItem instanceof AbstractGroupItem) {
            this.itemCollection.remove(rootGroup);

            const items = groupItem.getItems();
            groupItem.clearItems();
            items.splice(items.indexOf(oldItem), 1);
            items.push(newItem);
            groupItem.addItems(items);

            this.itemCollection.add(rootGroup);
        }
    }

    _findRootGroup(item) {
        let parentGroup = item.getParent();
        let rootGroup;

        while (parentGroup) {
            rootGroup = parentGroup;
            parentGroup = parentGroup.getParent();
        }

        return rootGroup;
    }

    /**
     * Return title
     *
     * @return {string}
     */
    getTitle() {
        if (this.replacements.length > 1) {
            return `Replace ${this.replacements.length} items`;
        }
        return 'Replace an item';
    }
}

namespace('Ofcs.Editor.Command');
window.Ofcs.Editor.Command.ReplaceItemsCommand = ReplaceItemsCommand;
